import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl.ts'
import Table from '@/shared/Tables/Table'
import useRegularTable from '@/shared/Tables/Table/ctrl/useRegularTable.ts'
import { memo } from 'react'
import { IAlarmSituation } from '../../alarmSituations.types.ts'
import alarmSituationsTableFields from './alarmSituations.table.fields.tsx'
import AlarmSituationsSidePage from '../AlarmSituationsSidePage'

interface IProps {
  items: IAlarmSituation[]
}

const ParameterTable = (props: IProps) => {
  const sidePageCtrl = useSidePageWithTableCtrl<IAlarmSituation>(props.items)

  const tableCtrl = useRegularTable({
    fields: alarmSituationsTableFields,
    tableKey: `alarmSituations`,
    itemKey: 'id',
    items: props.items,
  })

  return (
    <>
      <Table
        {...tableCtrl}
        items={props.items as any}
        itemKey="id"
        onClick={sidePageCtrl.handleItemPageOpen}
        loading={false}
      />
      <AlarmSituationsSidePage
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
        alarmSituation={sidePageCtrl.selectedItem}
      />
    </>
  )
}

export default memo(ParameterTable)
